import { scrollToId } from "@/lib/scroll";

/**
 * requestLead — arahkan pengunjung ke formulir lead dengan intent tertentu.
 * LeadForm mendengarkan event ini untuk pre-set segmen (audience) & kebutuhan.
 * intent: { audience: "b2c"|"b2b"|"commercial", kebutuhan?: string }
 */
export function requestLead(intent = {}) {
  window.dispatchEvent(new CustomEvent("sejukara:lead-intent", { detail: intent }));
  scrollToId("lead-form");
}

export default requestLead;
